export default "__VITE_ASSET__DtyXpKNV__"